import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { ArmaDate } from 'src/app/classes/utilit';
import { AppToolbarService } from 'src/app/components/toolbar/services/app-toolbar.service';

interface TypeTask {
  DESCRIPTION: any;
  CREATION_DATE: any;
  CONTACT: any;
  PERSON_IN_CHARGE: any;
  IS_STARTED: any;
  IS_FINISH: any;
}

@Component({
  selector: 'app-see-ticket',
  templateUrl: './see-ticket.component.html',
  styleUrls: ['./see-ticket.component.css']
})
export class SeeTicketComponent implements OnInit {

  displayedColumns: string[] = ['CREATION_DATE', 'CONTACT', 'DESCRIPTION', 'PERSON_IN_CHARGE', 'STATUS'];
  arrayTicket: TypeTask[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private mHttp: HttpClient,
    private mToolbar: AppToolbarService
  ) { }

  ngOnInit(): void {
    this.mToolbar.setVisibility(false);
    this.loadTicketUsine();
    setInterval(() => this.loadTicketUsine(), 60000);
  }

  private async loadTicketUsine() {
    let numsociete = this.route.snapshot.params.numsociete;
    await ArmaServConnection.isSessionValid(this.mHttp);  // Check de la session / renouvelle si expiré
    this.arrayTicket = await (await ArmaServConnection.aGET(this.mHttp, 'GetListTicket', [numsociete])).result[0];
  }

  getDate(elem: TypeTask) {
    return ArmaDate.createFromUnixTime(elem.CREATION_DATE).toDate();
  }

  getStatus(elem: TypeTask): string {
    if (!elem) return 'inconnu';
    if (elem.IS_FINISH) return 'Fini';
    else if (elem.IS_STARTED) return 'En cours';
    return 'Waiting';
  }

  getTrBackgroundClass(elem: TypeTask): any {
    let result: any = {};
    if (elem.IS_FINISH)
      result["bg-done"] = true;
    else if (elem.IS_STARTED)
      result["bg-inprog"] = true;
    return result;
  }

  public createNewTicket() {
    this.router.navigateByUrl('/ticket?numsociete=' + this.route.snapshot.params.numsociete);
  }
}
